import { RxDashboard } from "react-icons/rx";
import Styles from "./SidePanel.module.css";
import { MdCoPresent, MdModeEdit } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { BiLogOut } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { LOGOUT } from "../Action/UserAction";
import { HiAcademicCap } from "react-icons/hi2";
import { TbBrandZoom } from "react-icons/tb";

import {
  IoIosCart,
  IoIosCloseCircleOutline,
  IoMdArrowRoundBack,
} from "react-icons/io";
import { FaCartShopping } from "react-icons/fa6";
import { RiStackFill } from "react-icons/ri";
import { FaBookReader } from "react-icons/fa";
export default function SidePanel({
  Page,
  SetSideBarOpen,
  SidebarOpen,
  active,
}) {
  const { Login_User_Loading, Login_User, Login_User_Error } = useSelector(
    (state) => state.USER_LOGIN_REDUCER
  );

  const MobileScreen = window.innerWidth;

  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = (e) => {
    e.preventDefault();
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function (OneSignal) {
      console.log("OneSignal methods:", Object.keys(OneSignal));
      OneSignal.logout();
    });

    dispatch(LOGOUT());
  };

  useEffect(() => {
    if (!Login_User) {
      Navigate("/");
    }
  });

  return (
    <>
      {/* <div className="left-menu" id="leftMenu"> */}
      <div className={Styles.SidePanel}>
        <div className={Styles.TopSection}>
          <div className={Styles.UserCircle}>
            <img src="/assets/image/user.svg" alt="user" />
            {MobileScreen <= 780 ? (
              <h2
                onClick={() => SetSideBarOpen(!SidebarOpen)}
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: "0px",
                  right: "20px",
                }}
              >
                <IoIosCloseCircleOutline />
              </h2>
            ) : (
              ""
            )}
            <div
              onClick={() =>
                Navigate(`/student/details-update/${Login_User?._id}`)
              }
              className={active ? Styles.Active : Styles.Deactive}
            >
              <span>
                <MdModeEdit />
              </span>
            </div>
          </div>
          <div>
            <h4>
              {Login_User?.First_Name
                ? Login_User?.First_Name + " " + Login_User?.Last_Name
                : ""}
            </h4>
            {/* <p>Joined at Dec 2023</p> */}
            {/* <button>Package</button> */}
            {/* <p>Speaking & Writing</p> */}
            {/* <p>Intermediate Package 002</p> */}
            <div className={Styles.Logout}>
              <button onClick={handleLogout}>
                <span>
                  <BiLogOut />
                </span>
                <span> Logout</span>
              </button>
            </div>
          </div>
        </div>
        {/* <span
          onClick={() => Navigate("/")}
          style={{
            fontSize: "25px",
            marginBottom: "5px",
            position: "absolute",
            left: "10px",
            top: "5px",
            color: "white",
            cursor: "pointer",
          }}
        >
          <IoMdArrowRoundBack />
        </span> */}

        <div className={Styles.BottomSection}>
          <Link onClick={() => SetSideBarOpen(false)} to="/dashboard">
            <div
              className={
                Page === "Dashboard" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <RxDashboard />{" "}
              </p>
              <p>Dashboard</p>
            </div>
          </Link>
          <Link onClick={() => SetSideBarOpen(false)} to="/Attendance">
            <div
              className={
                Page === "Attendance" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <MdCoPresent />
              </p>
              <p>Attendance</p>
            </div>
          </Link>

          <Link onClick={() => SetSideBarOpen(false)} to="/Purchases">
            <div
              className={
                Page === "Purchases" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <FaCartShopping />
              </p>
              <p>Purchases</p>
            </div>
          </Link>
          {/* <Link onClick={() => SetSideBarOpen(false)} to="/online-classes">
            <div
              className={
                Page === "Online Classes"
                  ? Styles.BtmActive
                  : Styles.BtmDeActive
              }
            >
              <p>
                <RxDashboard />{" "}
              </p>
              <p>Online Classes</p>
            </div>
          </Link> */}
          <Link onClick={() => SetSideBarOpen(false)} to="/course-material">
            <div
              className={
                Page === "Materials" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <RiStackFill />
              </p>
              <p>Materials</p>
            </div>
          </Link>
          <Link onClick={() => SetSideBarOpen(false)} to="/Academy">
            <div
              className={
                Page === "Academy" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <HiAcademicCap />
              </p>
              <p>Academy</p>
            </div>
          </Link>
          {/* <Link onClick={() => SetSideBarOpen(false)} to="/mock-test-dashboard">
            <div
              className={
                Page === "Mock Test" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <RxDashboard />{" "}
              </p>
              <p>Mock Test</p>
            </div>
          </Link> */}

          <Link onClick={() => SetSideBarOpen(false)} to="/live-classes">
            <div
              className={
                Page === "Live Classes" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <TbBrandZoom />
              </p>
              <p>Live Classes</p>
            </div>
          </Link>

        

          <Link onClick={() => SetSideBarOpen(false)} to="/cart">
            <div
              className={
                Page === "Cart" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <IoIosCart />
              </p>
              <p>Cart</p>
            </div>
          </Link>

           <Link onClick={() => SetSideBarOpen(false)} to="/Recorded-classes">
            <div
              className={
                Page === "Recorded Classes" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <TbBrandZoom />
              </p>
              <p>Recorded </p>
            </div>
          </Link>

          <Link onClick={() => SetSideBarOpen(false)} to="/student/books">
            <div
              className={
                Page === "Book" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <FaBookReader />
              </p>
              <p>Books</p>
            </div>
          </Link>

          {/* <Link onClick={() => SetSideBarOpen(false)} to="/mock-test-dashboard">
            <div
              className={
                Page === "Mock Test" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <RxDashboard />
              </p>
              <p>Mock Test</p>
            </div>
          </Link>
          <Link onClick={() => SetSideBarOpen(false)}>
            <div
              className={
                Page === "Videos" ? Styles.BtmActive : Styles.BtmDeActive
              }
            >
              <p>
                <RxDashboard />
              </p>
              <p>Videos</p>
            </div>
          </Link> */}
        </div>
      </div>
      {/* </div> */}
    </>
  );
}
